// src/context/FavoritesContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { loadFavorites, loadAddfavorites } from "../constants/products";
import Swal from "sweetalert2";

// cache a nivel módulo
let cachedFavorites = null;

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cargar favoritos solo una vez
  useEffect(() => {
    const fetchFavorites = async () => {
      const loggedUserData = localStorage.getItem("user");
      if (!loggedUserData) {
        setLoading(false);
        return;
      }

      const userData = JSON.parse(loggedUserData);
      const userId = userData?.data?.user?.id;
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        // Solo carga si el cache no está disponible
        if (!cachedFavorites) {
          const data = await loadFavorites(userId);
          cachedFavorites = Array.isArray(data) ? data : [];
        }
        setFavorites(cachedFavorites);
      } catch (error) {
        console.error("Error al cargar favoritos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);

  // Función para agregar o eliminar favoritos
  const toggleFavorite = async (product) => {
    const loggedUserData = JSON.parse(localStorage.getItem("user"));
    if (!loggedUserData?.data?.user?.id) {
      Swal.fire("Debes iniciar sesión", "", "warning");
      return false;
    }

    const userId = loggedUserData.data.user.id;
    const isFav = favorites.some((f) => f.codigo === product.codigo);
    const borrar = isFav ? 1 : 0;

    try {
      await loadAddfavorites(userId, product.codigo, borrar);

      if (borrar === 1) {
        const updated = favorites.filter((f) => f.codigo !== product.codigo);
        setFavorites(updated);
        cachedFavorites = updated;
        Swal.fire("Eliminado de favoritos", "", "success");
      } else {
        const updated = [...favorites, { codigo: product.codigo }];
        setFavorites(updated);
        cachedFavorites = updated;
        Swal.fire("Añadido a favoritos", "", "success");
      }

      return true;
    } catch (error) {
      console.error("Error al actualizar favoritos:", error);
      Swal.fire("Error", "No se pudo actualizar favoritos.", "error");
      return false;
    }
  };

  return (
    <FavoritesContext.Provider
      value={{ favorites, toggleFavorite, loading }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
